(() => {
	Array.from(document.querySelectorAll('.sidebar-section a')).forEach(
		(el) => {
			if (el.getAttribute('href') === window.location.href) {
				el.classList.add('active');
			}
		}
	);
})();
